export default __webpack_public_path__ + "static/van-dfsk-c2a192e1410aec54897af8eaca02c671.png";